module.exports = __webpack_public_path__ + "static/media/logoaf.94467bed.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logoaf.png
 ** module id = 103
 ** module chunks = 0
 **/